var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppFlowTransition',[(_vm.showSteps)?_c('div',[_c('div',{staticClass:"stepper"},_vm._l((_vm.steps),function(blok,i){return _c('div',{key:i,staticClass:"stepper-item",class:{ active: i < _vm.getStep + 1 }},[_c('span',[_vm._v(_vm._s(blok.ShortTitle))])])}),0)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }